import type { ChangeEventHandler } from 'react'

import InfoBox from '@/components/InfoBox'
import CheckboxField from '@/components/inputs/CheckboxField'

type Props = {
  checked: boolean
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

export const PickupOnlyPrompt = ({
  checked,
  className = '!mb-10',
  onChange,
}: Props) => (
  <InfoBox custom className={className}>
    <CheckboxField
      checked={checked}
      label={
        <p className="mb-0">
          <span className="b1350:hidden ">
            I only wish to enter information required for the carrier to confirm
            the load. I will enter other information prior to printing a BOL.
          </span>
          <span className="b1350:inline hidden ">
            Only input information required for the carrier to confirm the load.
            Enter other info prior to printing a BOL.
          </span>
        </p>
      }
      labelClassName="whitespace-normal"
      name="isPickupOnly"
      onChange={onChange}
    />
  </InfoBox>
)
